import { jsx as _jsx } from "react/jsx-runtime";
import BasePage from "../base/BasePage";
import { usePCNotAUserCheck } from "./usePCNotAUserCheck";
var CheckPCNotAUser = function () {
    var isPCUser = usePCNotAUserCheck().isPCUser;
    return isPCUser ? _jsx(BasePage, {}) : null;
};
export default CheckPCNotAUser;
